import React from 'react';
import Loadable from 'react-loadable';
export var LoadableBrowseRovoAgentsModal = Loadable({
  loader: function loader() {
    return import( /* webpackChunkName: "@atlaskit-internal_editor-ai-browse-rovo-agents-modal" */
    './index').then(function (mod) {
      return mod.default;
    });
  },
  loading: function loading() {
    return null;
  }
});
export var PreloadModalComponent = function PreloadModalComponent() {
  React.useEffect(function () {
    LoadableBrowseRovoAgentsModal.preload();
  }, []);
  return null;
};